import { CommonPageALMeta } from '@lemon8/web-app-shared/ssr';
import { getCanonicalUrl } from './tdk';

export const HomepageFacebookALMeta = () => {
  const alMetaInfo = {
    openUrl: 'snssdk2657://main?channel_id=0&tab=home?pid=seo_al_fb',
    webUrl: getCanonicalUrl(),
  };

  return <CommonPageALMeta {...alMetaInfo} />;
};
